/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import FeelingEvasSectionContent from "core/components/feeling-evas/sliders/component";
import ForcJournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import { EmberChangeset } from "ember-changeset";
export default class extends FeelingEvasSectionContent {}